// // import React from "react";
// import React, { useState } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
// import ChatWindow from "./components/ChatWindow";
// import AgentDashboard from "./components/AgentDashboard";
// import TSECopilotDashboard from "./components/TSECopilotDashboard";
// import TSEAgentRag from "./components/TSEAgentRag";
// import AppLayout from "./components/AppLayout"; // <-- Adjust path as needed
// import Login from "./components/Login";
// import DiscoverPage from "./components/DiscoverPage";
// import CacheBuster from "./components/CacheBuster";

// function AppContent() {
//   const location = useLocation();
//   const [auth, setAuth] = useState(() => {
//     // Try to load from localStorage for persistence
//     const token = localStorage.getItem("token");
//     const role = localStorage.getItem("role");
//     const username = localStorage.getItem("username");
//     return token && role && username ? { token, role, username } : null;
//   });

//   const handleLogin = (token, role, username) => {
//     setAuth({ token, role, username });
//     localStorage.setItem("token", token);
//     localStorage.setItem("role", role);
//     localStorage.setItem("username", username);
//   };

//   const handleLogout = () => {
//     setAuth(null);
//     localStorage.removeItem("token");
//     localStorage.removeItem("role");
//     localStorage.removeItem("username");
//   };

//   // Determine position based on current route
//   const getCacheBusterPosition = () => {
//     if (location.pathname === '/agent') {
//       return 'left'; // Agent dashboard - left side
//     } else {
//       return 'right'; // Chat window and other pages - right side
//     }
//   };

//   return (
//     <>
//       <CacheBuster position={getCacheBusterPosition()} />
//       <AppLayout>
//         <Routes>
//           {/* Login route */}
//           <Route
//             path="/"
//             element={
//               auth ? (
//                 auth.role === "agent" ? <Navigate to="/agent" /> : <Navigate to="/ai-agent" />
//               ) : (
//                 <Login onLogin={handleLogin} />
//               )
//             }
//           />
//           {/* User chat route */}
//           <Route
//             path="/ai-agent"
//             element={
//               auth && auth.role === "user" ? (
//                 <ChatWindow username={auth.username} onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/" />
//               )
//             }
//           />
//           {/* Agent dashboard route */}
//           <Route
//             path="/agent"
//             element={
//               auth && auth.role === "agent" ? (
//                 <AgentDashboard onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/" />
//               )
//             }
//           />
//           {/* TSE Copilot Dashboard route */}
//           <Route
//             path="/TseDashboard"
//             element={
//               auth && auth.role === "agent" ? (
//                 <TSECopilotDashboard onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/" />
//               )
//             }
//           />
//           {/* TSE Agent RAG route */}
//           <Route
//             path="/TseAgentRag"
//             element={
//               auth && auth.role === "agent" ? (
//                 <TSEAgentRag onLogout={handleLogout} />
//               ) : (
//                 <Navigate to="/" />
//               )
//             }
//           />
//           <Route path="/discover" element={<DiscoverPage />} />
//           {/* Safety net: Redirect old /chat route to new /ai-agent route */}
//           <Route path="/chat" element={<Navigate to="/ai-agent" replace />} />
//         </Routes>
//       </AppLayout>
//     </>
//   );
// }

// function App() {
//   return (
//     <Router>
//       <AppContent />
//     </Router>
//   );
// }

// export default App;

// import React from "react";
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import ChatWindow from "./components/ChatWindow";
import AgentDashboard from "./components/AgentDashboard";
import TSECopilotDashboard from "./components/TSECopilotDashboard";
import TSEAgentRag from "./components/TSEAgentRag";
import AppLayout from "./components/AppLayout"; // <-- Adjust path as needed
import Login from "./components/Login";
import DiscoverPage from "./components/DiscoverPage";
import CacheBuster from "./components/CacheBuster";

function AppContent() {
  const location = useLocation();
  const [auth, setAuth] = useState(() => {
    // Try to load from localStorage for persistence
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    const username = localStorage.getItem("username");
    return token && role && username ? { token, role, username } : null;
  });

  const handleLogin = (token, role, username) => {
    setAuth({ token, role, username });
    localStorage.setItem("token", token);
    localStorage.setItem("role", role);
    localStorage.setItem("username", username);
  };

  const handleLogout = () => {
    setAuth(null);
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("username");
  };

  // Determine position based on current route
  const getCacheBusterPosition = () => {
    if (location.pathname === '/agent') {
      return 'left'; // Agent dashboard - left side
    } else {
      return 'right'; // Chat window and other pages - right side
    }
  };

  return (
    <>
      <CacheBuster position={getCacheBusterPosition()} />
      <AppLayout>
        <Routes>
          {/* Default route - now goes to Discover page */}
          <Route path="/" element={<DiscoverPage />} />
          
          {/* Login route */}
          <Route
            path="/login"
            element={
              auth ? (
                auth.role === "agent" ? <Navigate to="/agent" /> : <Navigate to="/ai-agent" />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />
          
          {/* User chat route */}
          <Route
            path="/ai-agent"
            element={
              auth && auth.role === "user" ? (
                <ChatWindow username={auth.username} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          
          {/* Agent dashboard route */}
          <Route
            path="/agent"
            element={
              auth && auth.role === "agent" ? (
                <AgentDashboard onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          
          {/* TSE Copilot Dashboard route */}
          <Route
            path="/TseDashboard"
            element={
              auth && auth.role === "agent" ? (
                <TSECopilotDashboard onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          
          {/* TSE Agent RAG route */}
          <Route
            path="/TseAgentRag"
            element={
              auth && auth.role === "agent" ? (
                <TSEAgentRag onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          
          {/* Discover page route */}
          <Route path="/discover" element={<DiscoverPage />} />
          
          {/* Safety net: Redirect old /chat route to new /ai-agent route */}
          <Route path="/chat" element={<Navigate to="/ai-agent" replace />} />
        </Routes>
      </AppLayout>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;